import { getValue } from '@service/firebase';
import { useMemo } from 'react';

const useFeatureFlags = () =>
  useMemo(
    () => ({
      features: {
        agentEditPhoneNumber: () =>
          !!getValue(
            'VITE_FEATURE_FLAG_SETTING_AGENT_EDIT_PHONE_NUMBER',
          )?.asBoolean(),
        agentEditEmail: () =>
          !!getValue('VITE_FEATURE_FLAG_SETTING_AGENT_EDIT_EMAIL')?.asBoolean(),
        areTargetValidation: () =>
          !!getValue(
            'VITE_FEATURE_FLAG_SET_ARE_TARGET_VALIDATION',
          )?.asBoolean(),
        createWeeklyMeetingMiddleware: () =>
          !!getValue(
            'VITE_FEATURE_FLAG_CREATE_WEEKLY_MEETING_MIDDLEWARE',
          )?.asBoolean(),
        maintainAssignmentAreListV2: () =>
          !!getValue(
            'VITE_FEATURE_FLAG_MAINTAIN_ASSIGNMENT_ARE_LIST_V2',
          )?.asBoolean(),
        selectMarketingId: () =>
          !!getValue('VITE_FEATURE_FLAG_SELECT_MARKETING_ID')?.asBoolean(),
        goalSettingsV2: () =>
          !!getValue('VITE_FEATURE_FLAG_GOAL_SETTINGS_V2')?.asBoolean(),
        activityDashboard: () =>
          !!getValue('VITE_FEATURE_FLAG_ACTIVITY_DASHBOARD')?.asBoolean(),
        agentManagementDetailV2: () =>
          !!getValue(
            'VITE_FEATURE_FLAG_AGENT_MANAGEMENT_DETAIL_V2',
          )?.asBoolean(),
        maintainSelfiePhoto: () =>
          !!getValue('VITE_FEATURE_FLAG_MAINTAIN_SELFIE_PHOTO')?.asBoolean(),
        spvMyKpiIncentive: () =>
          !!getValue('VITE_FEATURE_FLAG_SPV_MY_KPI_INCENTIVE')?.asBoolean(),
        agentReactivateApiV2: () =>
          !!getValue('VITE_FEATURE_FLAG_AGENT_REACTIVATE_API_V2')?.asBoolean(),
        agentReassignApiV2: () =>
          !!getValue('VITE_FEATURE_FLAG_AGENT_REASSIGN_API_V2')?.asBoolean(),
        editAgentApiV2: () =>
          !!getValue('VITE_FEATURE_FLAG_EDIT_AGENT_API_V2')?.asBoolean(),
        spvPerformanceComparison: () =>
          !!getValue(
            'VITE_FEATURE_FLAG_SPV_PERFORMANCE_COMPARISON',
          )?.asBoolean(),
        maintainReportV2: () =>
          !!getValue('VITE_FEATURE_FLAG_MAINTAIN_REPORT_V2')?.asBoolean(),
        recruitmentListV2: () =>
          !!getValue('VITE_FEATURE_FLAG_RECRUITMENT_LIST_V2')?.asBoolean(),
        recruitmentDownloadV2: () =>
          !!getValue('VITE_FEATURE_FLAG_RECRUITMENT_DOWNLOAD_V2')?.asBoolean(),
        brochureListForAmBm: () =>
          !!getValue('VITE_FEATURE_FLAG_BROCHURE_LIST_FOR_AM_BM')?.asBoolean(),
        createJoinVisitReportV2: () =>
          !!getValue(
            'VITE_FEATURE_FLAG_CREATE_JOIN_VISIT_REPORT_V2',
          )?.asBoolean(),
        branchRoutineChecklist: () =>
          !!getValue('VITE_FEATURE_FLAG_BRANCH_ROUTINE_CHECKLIST')?.asBoolean(),
        showCompanyName: () =>
          !!getValue('VITE_FEATURE_FLAG_SHOW_COMPANY_NAME')?.asBoolean(),
        showNotification: () =>
          !!getValue('VITE_FEATURE_FLAG_SHOW_NOTIFICATION')?.asBoolean(),
        leadsTrackerBlacklist: () =>
          !!getValue('VITE_FEATURE_FLAG_LEADS_TRACKER_BLACKLIST')?.asBoolean(),
        agentDocumentUnsigned: () =>
          !!getValue('VITE_FEATURE_FLAG_AGENT_DOCUMENT_UNSIGNED')?.asBoolean(),
        dynamicSpv1On1Suggestions: () =>
          !!getValue(
            'VITE_FEATURE_FLAG_DYNAMIC_SPV_1ON1_SUGGESTIONS',
          )?.asBoolean(),
        leadsTrackerDetailV2: () =>
          !!getValue('VITE_FEATURE_FLAG_LEADS_TRACKER_DETAIL_V2')?.asBoolean(),
        isAgencyMarketingKrakendEnable: () =>
          !!getValue(
            'VITE_FEATURE_FLAG_IS_AGENCY_MARKETING_KRAKEND_ENABLE',
          )?.asBoolean(),
        isKeycloakLoginWithSso: () =>
          !!getValue(
            'VITE_FEATURE_FLAG_IS_KEYCLOAK_LOGIN_WITH_SSO',
          )?.asBoolean(),
      },
      routes: {
        agentManagementForPBF: () =>
          !!getValue('VITE_FEATURE_FLAG_AGENT_MANAGEMENT_FOR_PBF')?.asBoolean(),
        agentManagementV2: () =>
          !!getValue('VITE_FEATURE_FLAG_AGENT_MANAGEMENT_V2')?.asBoolean(),
        hierarchyForPBF: () =>
          !!getValue('VITE_FEATURE_FLAG_HIERARCHY_FOR_PBF')?.asBoolean(),
        kpiIncentiveForPBF: () =>
          !!getValue('VITE_FEATURE_FLAG_KPI_INCENTIVE_FOR_PBF')?.asBoolean(),
        '1on1ForPBF': () =>
          !!getValue('VITE_FEATURE_FLAG_1ON1_FOR_PBF')?.asBoolean(),
      },
    }),
    [],
  );

export default useFeatureFlags;
